// One requestAnimationFrame loop for everything that moves with the music. It reads `engine.frame()` once per frame and hands the same
// object to each listener; listeners write to the DOM directly. Nothing here re-renders the Preact tree.

import { engine, type Frame } from '../engine/engine.js';

type Listener = (frame: Frame) => void;

const listeners = new Set<Listener>();
let raf = 0;

function loop(): void {
  const frame = engine.frame();
  for (const l of listeners) l(frame);
  raf = requestAnimationFrame(loop);
}

/** Call `listener` on every animation frame until the returned function is called. */
export function onFrame(listener: Listener): () => void {
  listeners.add(listener);
  if (listeners.size === 1) raf = requestAnimationFrame(loop);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) cancelAnimationFrame(raf);
  };
}
